import {
    InteractionRequiredAuthError,
    type PublicClientApplication,
} from '@azure/msal-browser';
import { getRuntimeAuthToken } from '@auth/runtime-token';
import { scopes } from './auth-config';

export default async function getToken(
    msal: PublicClientApplication,
): Promise<string | undefined> {
    const runtimeToken = getRuntimeAuthToken();
    if (runtimeToken) {
        return runtimeToken;
    }

    // Keep this gate an inline expression so Vite strips the branch from builds.
    // The token comes from a dev-server-injected global, never import.meta.env,
    // because Vite can inline the whole env object into production bundles.
    if (
        import.meta.env.DEV &&
        import.meta.env.VITE_LOCAL_AUTH_BYPASS === 'true'
    ) {
        return window.__LOCAL_AUTH_TOKEN__;
    }

    await msal.initialize();
    const activeAccount = msal.getActiveAccount();
    const accounts = msal.getAllAccounts();

    if (!activeAccount && accounts.length === 0) {
        throw new Error('No active user found');
    }

    const request = {
        scopes,
        account: activeAccount ?? accounts[0],
    };

    return msal
        .acquireTokenSilent(request)
        .then((accessTokenResponse) => {
            return accessTokenResponse.accessToken;
        })
        .catch((error: unknown) => {
            if (error instanceof InteractionRequiredAuthError) {
                return msal
                    .acquireTokenPopup(request)
                    .then((accessTokenResponse) => {
                        return accessTokenResponse.accessToken;
                    })
                    .catch((error: unknown) => {
                        console.error(error);
                        return undefined;
                    });
            }
        });
}
